import { render, staticRenderFns } from "./studentResponseOptBar.vue?vue&type=template&id=afd4cf38&scoped=true"
import script from "./studentResponseOptBar.vue?vue&type=script&lang=js"
export * from "./studentResponseOptBar.vue?vue&type=script&lang=js"
import style0 from "./studentResponseOptBar.vue?vue&type=style&index=0&id=afd4cf38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afd4cf38",
  null
  
)

export default component.exports